import { render, staticRenderFns } from "./MemberConfigList.vue?vue&type=template&id=3f05296c&scoped=true&lang=pug&"
import script from "./MemberConfigList.vue?vue&type=script&lang=ts&"
export * from "./MemberConfigList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f05296c",
  null
  
)

export default component.exports